export const GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_ABORTED =
  'GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_ABORTED';
export const GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_REQUESTED =
  'GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_REQUESTED';
export const GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_COMPLETED =
  'GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_COMPLETED';
export const GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_FAILED =
  'GET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_FAILED';
export const SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_ABORTED =
  'SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_ABORTED';
export const SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_REQUESTED =
  'SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_REQUESTED';
export const SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_COMPLETED =
  'SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_COMPLETED';
export const SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_FAILED =
  'SET_CLIENTWITHDRAWALSALLOW_FOR_ACCOUNT_FAILED';
